// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"9138cc13","133":"86e9f5b2","182":"4e236fc4","196":"fc015379","263":"7d4a508d","298":"a1fceb42","317":"a3c8e377","462":"4b63fc6a","508":"97e0942b","551":"c2ddb01f","564":"e55adb9c","580":"83b665f4","672":"477a6254","842":"01821987","940":"81efbd61"}[chunkId] + ".chunk.js";
};